import React, { Component } from "react";
import { Alert } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import moment from "moment";
import "moment/locale/es";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { ModalItem, ButtonItem } from "../../../../../Components/Items";
import resumenRegularizarInventarioPdf from "../../../../../Pdf/resumenRegularizarInventarioPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

moment.locale("es");

const IFRAME_NAME = "ResumenRegularizacionIframe";

class ModalResumenRegularizacion extends Component {
  pdf = null;

  componentDidUpdate(prevProps) {
    // El PDF se arma una sola vez, cuando el modal se abre con un resumen nuevo.
    if (this.props.visible && (!prevProps.visible || prevProps.resumen !== this.props.resumen)) {
      this.generarPdf();
    }
    if (!this.props.visible && prevProps.visible) {
      this.pdf = null;
    }
  }

  componentWillUnmount() {
    if (this.previewTimeout) clearTimeout(this.previewTimeout);
    if (this.descargaTimeout) clearTimeout(this.descargaTimeout);
  }

  nombreArchivo = () =>
    `ResumenRegularizacionInventario_${moment(this.props.resumen?.fecha).format(
      "YYYY-MM-DD_HHmm"
    )}.pdf`;

  generarPdf = () => {
    if (!this.props.resumen) return;
    const docDefinition = resumenRegularizarInventarioPdf({
      resumen: this.props.resumen,
      empresa: this.props.empresa,
    });
    this.pdf = pdfMake.createPdf(docDefinition);
    this.previewEnIframe();
    // Se pidio modal Y descarga automatica: el resumen queda guardado sin depender
    // de que el usuario le pique al boton. Va despues de la vista previa para que
    // primero se vea el PDF y luego salte la descarga.
    if (this.descargaTimeout) clearTimeout(this.descargaTimeout);
    this.descargaTimeout = setTimeout(this.descargar, 400);
  };

  // El iframe del modal puede no estar todavia en el DOM en el primer intento.
  previewEnIframe = (intento = 0) => {
    if (!this.pdf) return;
    if (window.frames[IFRAME_NAME]) {
      this.pdf.open({}, window.frames[IFRAME_NAME]);
      return;
    }
    if (intento >= 5) return;
    if (this.previewTimeout) clearTimeout(this.previewTimeout);
    this.previewTimeout = setTimeout(() => this.previewEnIframe(intento + 1), 150);
  };

  descargar = () => {
    if (!this.pdf) return;
    this.pdf.download(this.nombreArchivo());
  };

  render() {
    const { visible, resumen, cerrarModalResumen } = this.props;
    const totales = resumen?.totales || {};
    const ventasConError = totales.ventasConError || 0;
    const ventasParciales = totales.ventasParciales || 0;
    const hayErroresProceso = Array.isArray(resumen?.errores) && resumen.errores.length > 0;

    return (
      <ModalItem
        title="Resumen de Regularizacion de Inventario"
        visible={visible}
        onCancel={cerrarModalResumen}
        paddingTop
        width={900}
        footer={null}
        spinning={false}
      >
        {ventasConError > 0 && (
          <Alert
            type="error"
            showIcon
            style={{ marginBottom: 10 }}
            message={`${ventasConError} ${
              ventasConError === 1 ? "venta quedo" : "ventas quedaron"
            } sin entregar`}
            description="El inventario ya se agrego, pero esas ventas hay que entregarlas manualmente. El PDF trae el folio, el cliente, el motivo y lo que falta de cada una."
          />
        )}

        {ventasConError === 0 && ventasParciales > 0 && (
          <Alert
            type="warning"
            showIcon
            style={{ marginBottom: 10 }}
            message={`${ventasParciales} ${
              ventasParciales === 1 ? "venta quedo" : "ventas quedaron"
            } entregadas solo en parte`}
            description="Revisa en el PDF que insumos siguen pendientes de cada venta."
          />
        )}

        {hayErroresProceso && (
          <Alert
            type="error"
            showIcon
            style={{ marginBottom: 10 }}
            message="Hubo errores al mover el inventario"
            description={resumen.errores.join(" | ")}
          />
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
            marginBottom: 10,
          }}
        >
          <ButtonItem icon={<DownloadOutlined />} type="primary" onClick={this.descargar}>
            Descargar PDF
          </ButtonItem>
          <ButtonItem danger onClick={cerrarModalResumen}>
            Cerrar
          </ButtonItem>
        </div>

        <iframe
          title="Resumen Regularizacion PDF"
          style={{ width: "100%", height: "70vh", border: "1px solid #d9d9d9" }}
          id={IFRAME_NAME}
          name={IFRAME_NAME}
        />
      </ModalItem>
    );
  }
}

export default ModalResumenRegularizacion;
